import React, { MouseEventHandler, useState,useEffect } from 'react'
import { FormControl, FormControlLabel, Radio, Checkbox, RadioGroup, Switch } from '@mui/material'
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { useSelector } from 'react-redux';
import CouponBox from '../../CouponBox';
import { updateOrderResetFrequency } from '../../../../../stateManagement/actions/manageCouponActions';


function OrderResetFreq() {
    const orderResetFrequency = useSelector((state: any) => state?.manageCoupons?.data?.recurrence?.orderResetFrequency);
    const [frequency, setFrequency] = React.useState(orderResetFrequency);

    const [optionsMap, setOptionsMap] = useState<{ [key: string]: boolean }>({
        "Monthly": false,
        "Weekly": false,
        "Daily": false
    });
    useEffect(() => {
        setFrequency(orderResetFrequency);
      }, [orderResetFrequency])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFrequency(event.target.value);
        updateOrderResetFrequency(event.target.value);
    };
    // const handleClick = (key: string) => {
    //     Object.keys(optionsMap).forEach(key => {
    //         optionsMap[key] = false;
    //     });
    //     setOptionsMap(prevState => ({
    //         ...prevState,
    //         [key]: !prevState[key] // Toggle the value
    //     }));
    //     setFrequency(key);
    //     updateOrderResetFrequency(key);
    // };


    return (
        <div className="order-reset-freq">
            <CouponBox disabled={false} showBorder={true} collapsible header={<CouponConfigurableLabel text={'order-reset-frequency'} style={{ color: 'inherit', padding: "10px", marginLeft: "10px" }} />}>
                <FormControl>
                    <RadioGroup
                        aria-label="frequency"
                        name="frequency"
                        value={frequency}
                        onChange={handleChange}
                    >
                        <FormControlLabel className="radio-order-reset-freq" value="Daily" control={<Radio />} label="Daily" />
                        <FormControlLabel className="radio-order-reset-freq" value="Weekly" control={<Radio />} label="Weekly" />
                        <FormControlLabel className="radio-order-reset-freq" value="Monthly" control={<Radio />} label="Monthly" />
                    </RadioGroup>
                </FormControl>
            </CouponBox>
        </div>
    )
}

export default OrderResetFreq;

// checked={false}
// checked={false}
// checked={false}